module.exports = __webpack_public_path__ + "img/6.0361ff1b.png";